<template>
  <span
    :class="order == 0 ? '' : order == 1 ? 'c-btn--sort-asc' : 'c-btn--sort-desc'"
    class="c-btn c-btn--sort"
    :data-type="name"
    @click="onClick($event)"
  >
  </span>
</template>

<script>
export default {
  props: {
    name: String,
    order: Number,
  },
  emits: ["on-click"],
  methods: {
    // ソートボタンクリック
    onClick: function(event) {
      event.preventDefault();
      this.$emit('on-click', this.name);
    },
  }
}
</script>
